/** One row from GET …/lessons/{id}/tests, used only for browser Check My Work in teacher preview. */
export type WorkerLessonTestInput = { id: string; name: string; testCode: string };

/** One text file of a playground project, path relative to the project root. */
export type ProjectWorkerFile = { path: string; content: string };

/** Messages main thread → Pyodide worker */
export type MainToWorkerMessage =
  | {
      type: "init";
      inputCtrl: SharedArrayBuffer;
      inputText: SharedArrayBuffer;
      interruptFlag: SharedArrayBuffer;
    }
  | { type: "run"; code: string; filename: string }
  | { type: "run_project"; files: ProjectWorkerFile[]; entryPath: string }
  | { type: "run_tests"; mainPy: string; tests: WorkerLessonTestInput[] }
  | { type: "stop" };

export type LessonTestCaseWorkerResult = { fn: string; ok: boolean; err?: string };

export type LessonTestBlockWorkerResult = {
  testId: string;
  testName: string;
  loadError: string | null;
  cases: LessonTestCaseWorkerResult[];
};

/** Messages Pyodide worker → main thread */
export type WorkerToMainMessage =
  | { type: "ready" }
  | { type: "stdout"; text: string }
  | { type: "stderr"; text: string }
  | { type: "input_request"; prompt: string }
  | { type: "turtle_clear" }
  | { type: "turtle_display"; html: string }
  | { type: "finished"; turtleHtml?: string }
  | { type: "stopped" }
  | { type: "error"; message: string }
  | { type: "project_files_sync"; files: ProjectWorkerFile[]; skippedPaths: string[] }
  | { type: "test_results"; results: LessonTestBlockWorkerResult[] }
  | { type: "tests_error"; message: string };

export type IdeOutputTab = "console" | "turtle";

export const PYODIDE_INDEX_VERSION = "0.26.4";

export const INPUT_SIGNAL_IX = 0;
export const INPUT_LENGTH_IX = 1;
export const SIGINT = 2;
